const customerSpaceRequestState = {
    requestingCustomerSpaceRequest: false
};
export default customerSpaceRequestState;
